<template>
  <div
    v-if="sidebarOpen"
    class="fixed inset-0 bg-black/40 z-[90] lg:hidden"
    @click="closeSidebar"
  />
  <aside
    class="fixed top-0 left-0 z-[100] h-[100vh] w-[280px] bg-white border-r border-gray-200 overflow-y-auto transition-transform duration-300 ease-in-out max-lg:-translate-x-full lg:translate-x-0"
    :class="{ 'max-lg:translate-x-0': sidebarOpen }"
  >
    <!-- Logo 和标题部分 -->
    <div class="p-4">
      <div class="flex items-center gap-1">
        <!-- <div
          class="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground"
        >
          <img src="/favicon.ico" alt="Logo" class="h-6 w-6" />
        </div>
        <span class="text-sm font-bold">银企通™ API</span> -->
        <img :src="logoImg" alt="Logo" class="h-15 w-auto" />
      </div>
    </div>

    <!-- 导航菜单部分 -->
    <div class="pl-4 pr-4">
      <div v-for="(section, index) in menuData" :key="index" class="space-y-4">
        <h3
          class="text-xs font-medium text-[oklab(0.145_0_0/0.7)] uppercase tracking-wider pt-6 pl-3"
        >
          {{ section.title }}
        </h3>
        <ul class="space-y-[6px]">
          <li
            v-for="(item, itemIndex) in section.items"
            :key="itemIndex"
            class="relative"
          >
            <!-- 普通菜单项 -->
            <router-link
              :to="item?.path"
              class="flex items-center rounded-md px-2 py-1 text-sm font-medium transition-colors hover:bg-[oklch(0.97_0_0)]"
              v-if="!item.submenu || item.submenu.length === 0"
              :class="
                isActive(item?.path)
                  ? 'bg-[oklch(0.97_0_0)] text-gray-800'
                  : 'text-gray-800'
              "
              @click="closeSidebar"
            >
              <div class="w-[16px] text-center">
                <font-awesome-icon :icon="item.icon" />
              </div>
              <span class="ml-2">{{ item.title }}</span>
            </router-link>

            <!-- 可展开菜单项 -->
            <div
              class="cursor-pointer flex items-center rounded-md px-2 py-1 text-sm font-medium transition-colors hover:bg-[oklch(0.97_0_0)]"
              :class="
                isActive(item?.path)
                  ? 'bg-[oklch(0.97_0_0)] text-gray-800'
                  : 'text-gray-800'
              "
              @click="toggleSubmenu(item)"
              v-else
            >
              <div class="w-[16px] text-center">
                <font-awesome-icon :icon="item.icon" />
              </div>
              <span class="ml-2">{{ item.title }}</span>
              <i
                class="fas fa-chevron-down text-xs transition-transform duration-200 ml-auto"
                :class="{ 'rotate-180': item.expanded }"
              ></i>
            </div>

            <!-- 子菜单 -->
            <ul
              v-if="item.expanded && item.submenu && item.submenu.length > 0"
              class="space-y-[6px] mt-0.5 ml-4 pl-2 border-l border-gray-200"
            >
              <li
                v-for="(child, childIndex) in item.submenu"
                :key="childIndex"
                class="relative"
              >
                <a
                  v-if="child?.path?.startsWith('#')"
                  href="javascript:void(0)"
                  class="flex items-center rounded-md px-2 py-1 text-sm font-medium transition-colors hover:bg-[oklch(0.97_0_0)]"
                  :class="
                    isActive(child?.path)
                      ? 'bg-[oklch(0.97_0_0)] text-gray-800'
                      : 'text-gray-800'
                  "
                  @click="handleAnchorClick(child?.path, child?.parentPath)"
                >
                  <span
                    v-if="child.icon === 'POST'"
                    class="text-[0.6rem] font-bold px-1 py-0.2 bg-green-100 text-green-800 rounded uppercase mr-2 shrink-0 w-9 text-center inline-block"
                    >POST</span
                  >
                  <span
                    v-else-if="child.icon === 'GET'"
                    class="text-[0.6rem] font-bold px-1 py-0.2 bg-blue-100 text-blue-800 rounded uppercase mr-2 shrink-0 w-9 text-center inline-block"
                    >GET</span
                  >
                  <font-awesome-icon v-else :icon="child.icon" class="mr-2" />
                  <span class="min-w-0 flex-1">{{ child.title }}</span>
                  <AdvancedFeatureBadge
                    v-if="
                      getAdvancedFeatureByApiUrl(
                        systemStore.advancedApiConfig,
                        child.apiUrl
                      )
                    "
                    class="ml-2 shrink-0"
                  />
                </a>
                <router-link
                  v-else
                  :to="child?.path"
                  class="flex items-center rounded-md px-2 py-1 text-sm font-medium transition-colors hover:bg-[oklch(0.97_0_0)]"
                  :class="
                    isActive(child?.path)
                      ? 'bg-[oklch(0.97_0_0)] text-gray-800'
                      : 'text-gray-800'
                  "
                  @click="closeSidebar"
                >
                  <!-- 特殊处理POST和GET标签 -->
                  <span
                    v-if="child.icon === 'POST'"
                    class="text-[0.6rem] font-bold px-1 py-0.2 bg-green-100 text-green-800 rounded uppercase mr-2 shrink-0 w-9 text-center inline-block"
                    >POST</span
                  >
                  <span
                    v-else-if="child.icon === 'GET'"
                    class="text-[0.6rem] font-bold px-1 py-0.2 bg-blue-100 text-blue-800 rounded uppercase mr-2 shrink-0 w-9 text-center inline-block"
                    >GET</span
                  >
                  <font-awesome-icon v-else :icon="child.icon" class="mr-2" />
                  <span class="min-w-0 flex-1">{{ child.title }}</span>
                  <AdvancedFeatureBadge
                    v-if="
                      getAdvancedFeatureByApiUrl(
                        systemStore.advancedApiConfig,
                        child.apiUrl
                      )
                    "
                    class="ml-2 shrink-0"
                  />
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </aside>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import logoImg from "@/assets/nexbank-api-chinese.png";
import { closeSidebar, sidebarOpen } from "@/composables/useLayout";
import AdvancedFeatureBadge from "@/components/ui/AdvancedFeatureBadge.vue";
import { getAdvancedFeatureByApiUrl } from "@/lib/advanced-features";
import { useSystemStore } from "@/stores/system";

const route = useRoute();
const router = useRouter();
const systemStore = useSystemStore();

// 定义菜单项的类型接口
interface SubMenuItem {
  title: string;
  path: string;
  icon: string;
  apiUrl?: string;
  parentPath?: string;
}

interface MenuItem {
  title: string;
  icon: string;
  apiUrl?: string;
  path?: string;
  expanded: boolean;
  submenu?: SubMenuItem[];
}

interface MenuSection {
  title: string;
  items: MenuItem[];
}

// 菜单数据
const menuData = ref<MenuSection[]>([
  {
    title: "开始使用",
    items: [
      {
        title: "快速开始",
        icon: "far fa-paper-plane",
        path: "/quick-start",
        expanded: false,
      },
      {
        title: "API介绍",
        icon: "far fa-file-alt",
        expanded: false,
        path: "/introduction",
        submenu: [
          {
            title: "API列表",
            path: "#api-list",
            parentPath: "/introduction",
            icon: "far fa-list-alt",
          },
          {
            title: "接口规范",
            path: "#specification",
            icon: "far fa-lightbulb",
            parentPath: "/introduction",
          },
        ],
      },
      {
        title: "SDK & Demo",
        icon: "far fa-map",
        path: "/sdk-demo",
        expanded: false,
      },
    ],
  },
  {
    title: "API 文档",
    items: [
      {
        title: "客户管理",
        icon: "far fa-user",
        expanded: false,
        submenu: [
          {
            title: "新建客户",
            path: "/new-customer",
            icon: "POST",
            apiUrl: "/api/v2/customer/create",
          },
        ],
      },
      {
        title: "签约管理",
        icon: "far fa-compass",
        expanded: false,
        // 使用 generated 中菜单
        // submenu: [
        // {
        //   title: "获取签约链接",
        //   path: "/sign-url",
        //   icon: "POST",
        // },
        // {
        //   title: "查询签约状态",
        //   path: "/sign-status",
        //   icon: "GET",
        // },
        // ],
      },
      {
        title: "数据查询",
        icon: "far fa-hourglass",
        expanded: false,
        // 使用 generated 中菜单
        // submenu: [
        // {
        //   title: "流水查询",
        //   path: "/transaction-query",
        //   icon: "POST",
        // },
        // {
        //   title: "每日余额查询",
        //   path: "/daily-balance",
        //   icon: "GET",
        // },
        // {
        //   title: "回单下载",
        //   path: "/receipt-download",
        //   icon: "GET",
        // },
        // ],
      },
      {
        title: "支付",
        icon: "far fa-credit-card",
        expanded: false,
        submenu: [
          {
            title: "单笔支付制单",
            path: "/payment/submit",
            icon: "POST",
            apiUrl: "/api/v2/payment/commonPay",
          },
          {
            title: "查询支付状态",
            path: "/payment/status-query",
            icon: "GET",
            apiUrl: "/api/v2/payment/transferStatus",
          },
          {
            title: "支行信息查询",
            path: "/api-v2-bank-searchbranch",
            icon: "GET",
            apiUrl: "/api/v2/bank/searchBranch",
          },
          {
            title: "批量转账(支付)制单",
            path: "/payment/batch-submit",
            icon: "POST",
            apiUrl: "/api/v2/payment/batchTransfer",
          },
          {
            title: "查询批量转账(支付)状态",
            path: "/payment/batch-status-query",
            icon: "GET",
            apiUrl: "/api/v2/payment/batchTransferStatus",
          },
          {
            title: "批量转账(支付)-明细支付状态查询",
            path: "/payment/batch-detail-status-query",
            icon: "GET",
            apiUrl: "/api/v2/payment/batchTransferDetailStatus",
          },
          {
            title: "跨境支付制单",
            path: "/payment/international-submit",
            icon: "POST",
            apiUrl: "/api/v2/payment/crossPay",
          },
          {
            title: "全球汇款制单",
            path: "/payment/global-submit",
            icon: "POST",
            apiUrl: "/api/v2/payment/globalPay",
          },
          {
            title: "境外汇款支付规则查询",
            path: "/payment/global-submit-rule-search-v2",
            icon: "GET",
            apiUrl: "/api/v2/payment/rule/search",
          },
          {
            title: "三方支付制单",
            path: "/payment/third-party-submit",
            icon: "POST",
            apiUrl: "/api/v2/payment/thirdPay",
          },
        ],
      },
    ],
  },
  {
    title: "开发指南",
    items: [
      {
        title: "常见问题",
        icon: "far fa-question-circle",
        path: "/faq",
        expanded: false,
      },
      {
        title: "安全概述",
        icon: "far fa-bell",
        path: "/security",
        expanded: false,
      },
      {
        title: "更新日志",
        path: "/changelog",
        icon: "far fa-calendar",
        expanded: false,
      },
      {
        title: "其它",
        path: "/dev-guide",
        icon: "far fa-map",
        expanded: false,
      },
    ],
  },
]);

// 动态合并生成的菜单（支持与现有分组合并，并在生成后重试）
let generatedMerged = false;

const loadGeneratedMenu = async () => {
  try {
    const mod = await import("@/generated/menu").catch(() => null);
    const generated = (mod?.default || []) as MenuSection[];
    if (!generated.length) return;

    const apiSectionIndex = menuData.value.findIndex(
      (s) => s.title === "API 文档",
    );
    const groupIcon = (name: string) => {
      if (name.includes("数据")) return "far fa-hourglass";
      if (name.includes("客户")) return "far fa-user";
      if (name.includes("签约")) return "far fa-compass";
      if (name.includes("支付")) return "far fa-credit-card";
      return "far fa-cube";
    };

    if (apiSectionIndex >= 0) {
      const apiItems = menuData.value[apiSectionIndex].items;
      generated.forEach((sec) => {
        const existingIndex = apiItems.findIndex(
          (it) => it.title === sec.title,
        );
        const toSubmenu = sec.items.map((it) => ({
          title: it.title,
          path: it?.path,
          icon: it.icon,
          apiUrl: it.apiUrl,
        }));
        if (existingIndex >= 0) {
          const existing = apiItems[existingIndex];
          existing.submenu = [...(existing.submenu || []), ...toSubmenu];
        } else {
          apiItems.push({
            title: sec.title,
            icon: groupIcon(sec.title),
            expanded: false,
            submenu: toSubmenu,
          });
        }
      });
      generatedMerged = true;
    } else {
      menuData.value.push({
        title: "API 文档（生成）",
        items: generated.map((sec) => ({
          title: sec.title,
          icon: groupIcon(sec.title),
          expanded: false,
          submenu: sec.items.map((it) => ({
            title: it.title,
            path: it?.path,
            icon: it.icon,
            apiUrl: it.apiUrl,
          })),
        })),
      });
      generatedMerged = true;
    }
  } catch (e) {
    // 忽略缺失的生成文件
  }
};

onMounted(async () => {
  // 自动生成目录
  await loadGeneratedMenu();
  // 防止组件先挂载后生成文件的情况，延迟重试一次
  setTimeout(() => {
    if (!generatedMerged) loadGeneratedMenu();
  }, 1200);
});

// 切换子菜单展开/收起状态
const toggleSubmenu = (item: MenuItem) => {
  item.expanded = !item.expanded;
};

// 检查菜单项是否激活
const isActive = (path: string) => {
  // 确保path存在且为字符串
  if (!path) return false;

  // 对于锚点链接，我们需要特殊处理
  if (path.startsWith("#")) {
    // 对于子菜单的锚点链接，检查是否在当前页面且锚点匹配
    const [basePath, anchor] = path.split("#");
    const currentBasePath = route?.path?.split("#")[0] || "";
    const currentAnchor = route?.path.split("#")[1] || "";

    // 如果基础路径匹配且锚点匹配，则高亮
    return currentBasePath === basePath && currentAnchor === anchor;
  }

  // 对于普通路由，精确匹配路径
  return route?.path === path;
};

// 处理锚点点击事件
const handleAnchorClick = (path: string, parentPath?: string) => {
  if (parentPath && parentPath !== route?.path) {
    router.push(parentPath);
  }
  // 延迟执行滚动操作
  setTimeout(() => {
    const anchor = path.substring(1); // 移除#前缀
    const element = document.getElementById(anchor);
    if (element) {
      // 使用scrollIntoView并考虑固定头部偏移
      const headerOffset = 72; // 固定头部高度
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - headerOffset - 20;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
    closeSidebar();
  }, 100);
};

// 监听路由变化，自动展开含有当前激活子项的菜单
watch(
  () => route?.path,
  (newPath) => {
    // 遍历所有菜单项，只将匹配当前路径的菜单项设置为展开状态
    // 不修改其他菜单项的状态，以支持多个菜单同时展开
    menuData.value.forEach((section) => {
      section.items.forEach((item) => {
        if (item.submenu && item.submenu.length > 0) {
          const hasActiveChild = item.submenu.some(
            (child) =>
              (child?.path?.startsWith("#")
                ? child.parentPath
                : child?.path) === newPath,
          );
          // 只有当找到匹配的子项时，才设置为展开状态
          if (hasActiveChild) {
            item.expanded = true;
          }
          // 不设置为false，保留用户之前打开的菜单状态
        }
      });
    });
  },
  { immediate: true },
);
</script>
